'use client';
import { useState, useEffect } from 'react';
import { Container, Modal } from 'react-bootstrap';
import './LandingPage.scss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useNavigate, useParams } from 'react-router-dom';
import appCompoLoading from '@/assets/animation/loading.json';

import Logo from '@/assets/img/logo-v2.svg';
import Bouquet from '@/assets/img/boquet.png';
import { LandingUser, Slot } from '../types';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import { useGetAvailabilities } from '../api/getAvailability';
import { useLandingDetails, useScheduleDemo, useScheduleDemoSlot } from '../api/bookAppointment';
import Lottie from 'lottie-react';

export default function LandingPage() {
  const { slug } = useParams();
  const useGetAvailabilitiesMutation = useGetAvailabilities();
  const useScheduleDemoMutation = useLandingDetails();
  const useScheduleSlotDemoMutation = useScheduleDemoSlot();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [userData, setUserData] = useState<LandingUser>({
    name: '',
    email: '',
    phone: '',
    storeName: '',
    zipCode: '',
    address: '',
    businessUserId: '',
    summary: 'Petsked Landing Leads',
    description: 'Petsked Landing Leads',
    promoCode: 'EXPOWEST',
  });
  const [showNextPage, setShowNextPage] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const saveUserData = async () => {
    const isFormValid = validate();
    if (isFormValid) {
      const { name, email, phone, storeName, zipCode, summary, description, address, promoCode } =
        userData;
      const res = await useScheduleDemoMutation.mutateAsync({
        data: {
          name,
          email:email.toLowerCase(),
          phone,
          storeName,
          address,
          zipCode,
          description,
          summary,
          promoCode,
        },
        headers: {
          // 'loc-id': hostBusinessData?.LocationUserModel?.businessLocationId,
        },
      });
      if (res) {
        setShowConfirmationModal(true);
      }
    }
  };
  const validate = () => {
    const { name, email, phone, storeName, address, zipCode } = userData;
    let errorMessage;
    if (!name || name.trim().length < 1) {
      errorMessage = 'Please enter your full name';
    } else if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      errorMessage = 'please enter valid email';
    } else if (!phone || phone.trim().length < 1) {
      errorMessage = 'Please enter valid phone number';
    } else if (!storeName || storeName.trim().length < 1) {
      errorMessage = 'Please enter valid store name';
    } else if (!address || address.trim().length < 1) {
      errorMessage = 'Please enter valid address';
    } else if (!zipCode || zipCode.trim().length < 1) {
      errorMessage = 'Please enter valid zip code';
    }
    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };
  const onFormValueChange = (formFieldName: string, value: string) => {
    const data: any = userData;
    if (userData) {
      data[formFieldName] = value;
    }
    setUserData({ ...data });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    // Regular expression to allow only numbers
    const regex = /^[0-9\b]+$/;
    if (inputValue === '' || regex.test(inputValue)) {
      const data: any = userData;
      if (userData) {
        data['zipCode'] = inputValue;
      }
      setUserData({ ...data });
    }
  };

  const onHideConfirmationModal = () => {
    setShowConfirmationModal(false);
    setUserData({
        name: '',
        email: '',
        phone: '1',
        storeName: '',
        zipCode: '',
        address: '',
        businessUserId: '',
        summary: 'Petsked Landing Leads',
        description: 'Petsked Landing Leads',
        promoCode: 'EXPOWEST',
      } as LandingUser);
  };
  return (
    <>
      <section className="petsked-container-no-bg  petsked-landing-page">
        <div className="content">
          <div>
            <div className="landing-brand-details">
            <a href="https://petsked.com/">
              <img className="landing-logo" src={Logo} alt="Logo" />
              </a>
            </div>
            <div className="schedule-step-1">
              <p className="desc"></p>
              <div className="details">
                <div className="meeting-details">
                  <span>
                    <div className="landing-title">YOUR EXCLUSIVE OFFER</div>
                    <p className="desc">
                      Transform your business with technology to streamline operations, simplify
                      scheduling, enhance customer management, expedite payments, and deliver an
                      outstanding customer experience
                    </p>
                    <ul className="landing-benifits">
                      <li>Get unlimited access to Petsked for 1 full year</li>
                      <li>Get published to a network of 100M monthly users</li>
                    </ul>
                  </span>
                </div>
                <div className="user-registration-form">
                  <div className="petsked-form">
                    <label>Personal Information</label>
                    <input
                      className="fn"
                      type="text"
                      value={userData?.name}
                      placeholder="Your full name"
                      maxLength={50}
                      onInput={(e: any) => onFormValueChange('name', e.target?.value)}
                    />
                    <div className="split personal">
                      <input
                        type="email"
                        value={userData?.email}
                        placeholder="Email address"
                        maxLength={50}
                        onInput={(e: any) => onFormValueChange('email', e.target?.value)}
                      />
                      <PhoneInput
                        country={'us'}
                        value={userData?.phone}
                        onChange={(data: any) => onFormValueChange('phone', data)}
                        placeholder='Phone number'
                        countryCodeEditable={false}
                      />
                    </div>
                    <hr />
                    <label>Business Information</label>
                    <input
                      className="fn"
                      type="text"
                      value={userData?.storeName}
                      placeholder="Business name"
                      onInput={(e: any) => onFormValueChange('storeName', e.target?.value)}
                      maxLength={50}
                    />
                    <div className="split">
                      <input
                        type="text"
                        value={userData?.address}
                        placeholder="Address"
                        onInput={(e: any) => onFormValueChange('address', e.target?.value)}
                      />
                      <input
                        type="text"
                        value={userData?.zipCode}
                        placeholder="Zip code"
                        maxLength={10}
                        onChange={handleChange}
                      />
                    </div>
                    <label className="promo-code">Promo Code</label>
                    <input
                      className="store-disabled-fiedl"
                      type="text"
                      value={userData?.promoCode}
                      placeholder="promo code"
                      onInput={(e: any) => onFormValueChange('storeName', e.target?.value)}
                      disabled={true}
                      maxLength={50}
                    />
                    <div className="landing-action">
                      <button className="petsked-btn dark" onClick={() => onHideConfirmationModal()}>
                        TRY PETSKED
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <Modal
            className="petsked-modal-dialog landing-page-confirmation-modal"
            show={showConfirmationModal}
            onHide={onHideConfirmationModal}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className="top">
                <img src={Bouquet} />
                <h5>Congratulations! </h5>
                <p>
                  Thank You for signing up for 1 YEAR FREE access to Petsked. Your request has been
                  received, and we will reach out to you shortly to set you up.
                </p>
              </div>
            </Modal.Body>
          </Modal>
        </div>
        {((showNextPage && useGetAvailabilitiesMutation.isLoading) ||
          useScheduleDemoMutation.isLoading ||
          useScheduleSlotDemoMutation.isLoading) && (
          <div className="preloader-schedule">
            {/* <div className="loader" /> */}
            <Lottie className="loader" animationData={appCompoLoading} />
          </div>
        )}
      </section>
      
    </>
  );
}